fragment PolicyDocumentFields on PolicyDocument {
  id
  version
  originalFilename
  uploadedByName
  createdAt
  updatedAt
  url
  readStatus
  readError
  pageCount
  readMethod
  suggestedSummary
  suggestedKeyPoints
  suggestionDismissedAt
}
